<template>
    <div>
        <!-- {{ active_case_type + " -- " + case_types }} -->
        <v-row justify="space-around" class="fix-mar-1 no-pd" fix>
            <v-progress-linear
                v-if="data_main.length === 0"
                indeterminate
                color="cyan"
            ></v-progress-linear>
            <v-col
                class="text-center"
                cols="2"
                v-for="(row, index) in data_main"
                :key="index"
                @click="get_group(row.case_type)"
            >
                <v-badge avatar bordered overlap class="mt-3">
                    <template v-slot:badge>
                        <v-avatar color="teal">
                            {{ row.total_case }}
                        </v-avatar>
                    </template>

                    <v-avatar
                        class="fix-avatar cur-p"
                        :color="
                            chkViewMain === 'managecase' &&
                            case_types === row.case_type
                                ? 'teal accent-1'
                                : 'blue lighten-5'
                        "
                    >
                        <v-icon large dark class="icon-main-menu">{{
                            row.icon
                        }}</v-icon>
                    </v-avatar>
                </v-badge>
                <br />
                <span
                    :class="
                        case_types === row.case_type
                            ? 'color-active fix-font-1'
                            : 'fix-font-1'
                    "
                    >{{ row.title_name }}</span
                >

                <div
                    v-if="
                        active_case_type != null &&
                            active_case_type != '' &&
                            chkViewMain === 'managecase'
                    "
                    class="mar-t-05"
                >
                    <v-chip
                        v-if="
                            active_case_type == 'A' &&
                                (row.case_type == 'back-order' ||
                                    row.case_type == 'hp' ||
                                    row.case_type == 'nonhp' ||
                                    row.case_type == 'asus')
                        "
                        x-small
                        color="amber"
                        >{{
                            row.case_type == "back-order"
                                ? count_a.backOrder
                                : row.case_type == "hp"
                                ? count_a.hp
                                : row.case_type == "asus"
                                ? count_a.hp
                                : count_a.nonHp
                        }}</v-chip
                    >
                    <v-chip
                        v-if="
                            active_case_type == 'B' &&
                                (row.case_type == 'bench' ||
                                    row.case_type == 'pm-install')
                        "
                        x-small
                        color="amber"
                        >{{
                            row.case_type == "bench"
                                ? count_a.bench
                                : count_a.pmInstall
                        }}</v-chip
                    >
                </div>
            </v-col>
        </v-row>

        <hr
            class="fix-hr-1 no-pd"
            v-if="chkViewMain === 'managecase' && case_types != ''"
        />

        <v-banner
            sticky
            style="z-index: 199"
            class="no-pd"
            v-if="chkViewMain === 'managecase' && case_types != ''"
        >
            <v-row :class="team_name === 'NONHP' ? 'div-scoll-case' : ''">
                <v-col
                    @click="
                        change_member(
                            rowMember.emp_id,
                            rowMember.emp_name_en,
                            rowMember.img_poth
                        )
                    "
                    cols="2"
                    v-for="(rowMember, idm) in data_member"
                    :key="idm"
                    :class="
                        chk_active_member === rowMember.emp_id
                            ? 'red-x text-center fix-en-pic ml-3'
                            : 'text-center fix-en-pic ml-3'
                    "
                >
                    <v-badge avatar bordered overlap class="mt-4">
                        <template v-slot:badge>
                            <v-avatar>
                                {{
                                    data_save[rowMember.emp_id]
                                        ? data_save[rowMember.emp_id].length
                                        : "0"
                                }}
                            </v-avatar>
                        </template>

                        <v-avatar size="40">
                            <img
                                :src="url_pic_img + rowMember.img_poth"
                                :alt="rowMember.emp_name_en"
                            />
                        </v-avatar>
                    </v-badge>
                    <br />

                    <v-chip
                        x-small
                        color="teal accent-3"
                        v-if="rowMember.role_name === 'Engineer'"
                    >
                        <span
                            :class="
                                rowMember.emp_name_en.length >= 13
                                    ? 'fix-f-14'
                                    : ''
                            "
                            >{{ rowMember.emp_name_en }}</span
                        >
                    </v-chip>
                    <span
                        class="fix-font-2"
                        v-if="rowMember.role_name != 'Engineer'"
                    >
                        {{ rowMember.emp_name_en }}
                    </span>
                </v-col>
            </v-row>
        </v-banner>

        <!-- <hr
            class="fix-hr-1"
            v-if="chkViewMain === 'managecase' && case_types != ''"
        /> -->

        <v-row align="center" class="no-pd" v-if="chkViewMain === 'managecase'">
            <v-expansion-panels :hover="true">
                <v-expansion-panel
                    v-for="(rowGroup, IndexGroup) in data_group"
                    :key="IndexGroup"
                    v-model="panel[IndexGroup]"
                    @click="func_panel(IndexGroup)"
                >
                    <v-expansion-panel-header
                        dense
                        color="blue darken-2"
                        @click="get_data_detail(rowGroup.site_province_id)"
                    >
                        <span class="fix-font-b">
                            {{ rowGroup.province_name_th }}
                        </span>

                        <div class="text-right mr-10">
                            <v-chip
                                small
                                dense
                                color="font-weight-black white pl-4 pr-4"
                            >
                                {{ rowGroup.num_case }}
                            </v-chip>
                        </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content
                        v-for="(r, IndexCase) in list"
                        :key="IndexCase"
                        class="blue lighten-5 mb-1"
                    >
                        <v-row>
                            <v-col
                                class="caption font-weight-bold pt-3"
                                v-if="r.case_id"
                                cols="10"
                            >
                                <v-chip
                                    small
                                    dense
                                    :color="
                                        r.special_status == 'uncontrol'
                                            ? 'red lighten-2'
                                            : 'blue lighten-2'
                                    "
                                    @click="
                                        change_case(
                                            r.case_id,
                                            rowGroup.site_province_id
                                        )
                                    "
                                >
                                    {{ r.case_id + " - " + r.subcase }}
                                </v-chip>

                                <v-chip class="ml-1" color="white" small dense>
                                    {{ r.amphur_name_th }}</v-chip
                                >
                                <v-tooltip top class="ml-1">
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            x-small
                                            v-on="on"
                                            fab
                                            @click="doCopyLog(r.case_id)"
                                        >
                                            <v-icon>mdi-content-copy</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Copy {{ r.case_id }}</span>
                                </v-tooltip>
                                <v-btn
                                    color="amber"
                                    fab
                                    x-small
                                    class="ml-1 elevation-4"
                                    :to="
                                        '/Project/ViewCasepending/' +
                                            team_name +
                                            '/' +
                                            r.maincase_id +
                                            '/ViewDetail'
                                    "
                                    target="_blank"
                                >
                                    <v-icon small>mdi-magnify</v-icon>
                                </v-btn>
                            </v-col>

                            <v-col
                                cols="2"
                                class="text-center fix-mar-2"
                                v-if="add_members['I' + r.case_id]"
                            >
                                <v-avatar size="30">
                                    <img
                                        :src="
                                            url_pic_img +
                                                active_member_en[
                                                    add_members['I' + r.case_id]
                                                ].img_poth
                                        "
                                        alt=""
                                    />
                                </v-avatar>

                                <p class="fix-font-3">
                                    {{
                                        active_member_en[
                                            add_members["I" + r.case_id]
                                        ].emp_name_en
                                    }}
                                </p>
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-4"
                                v-if="r.created_date"
                                cols="12"
                            >
                                วันที่เปิดงาน : {{ r.created_date }}
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-3"
                                v-if="r.site_name"
                                cols="12"
                            >
                                <v-icon class="pr-1 pb-1" color="red" small
                                    >mdi-home</v-icon
                                >{{ r.site_name }}
                            </v-col>

                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-3"
                                v-if="r.site_address"
                                cols="12"
                            >
                                <v-icon class="pr-1 pb-1" color="red" small
                                    >mdi-home-map-marker</v-icon
                                >{{ r.site_address }}
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-3"
                                cols="12"
                            >
                                <v-icon class="pr-1 pb-1" color="primary" small>
                                    mdi-account-circle</v-icon
                                >
                                <span class="primary--text">{{
                                    r.customer_name
                                }}</span>
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-3"
                                cols="12"
                                v-for="phone in r.customer_tel"
                                :key="phone"
                            >
                                <v-icon style="color: #dbb20d">
                                    mdi-whatsapp
                                </v-icon>
                                <a
                                    style="color: #dbb20d; font-weight: bold"
                                    :href="`tel:${phone}`"
                                    class="pr-1 pb-1"
                                    small
                                    >{{ phone }}</a
                                >
                            </v-col>

                            <v-col
                                class="caption font-weight-bold pb-0 pt-0 color-font-c-2"
                                v-if="r.case_title"
                                cols="12"
                            >
                                <v-chip
                                    color="white"
                                    class="mr-1"
                                    x-small
                                    dense
                                >
                                    {{ r.project_name }}</v-chip
                                >{{ r.case_title }}
                                <br v-if="r.subcase_title" />
                                <v-chip
                                    v-if="r.subcase_title"
                                    x-small
                                    color="purple lighten-4"
                                    >{{ r.subcase_title }}</v-chip
                                >
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-4"
                                v-if="r.product_serial"
                                cols="12"
                            >
                                Product No : {{ r.product_no }}
                            </v-col>

                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 indigo--text"
                                v-if="r.product_serial"
                                cols="12"
                            >
                                SN : {{ r.product_serial }}
                            </v-col>

                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-2"
                                v-if="r.remark"
                                cols="12"
                            >
                                <v-icon class="pr-1 pb-1" small
                                    >mdi-chat-alert</v-icon
                                >{{ r.remark }}
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-1"
                            >
                                <div v-if="r.parts.length == 0">
                                    <p class="ma-0">
                                        <v-icon class="pr-1 pb-1" small
                                            >mdi-pound</v-icon
                                        >Checking
                                    </p>
                                </div>
                                <div
                                    v-else
                                    v-for="(part, i) in r.parts"
                                    :key="i"
                                >
                                    <p
                                        class="ma-0"
                                        :style="
                                            part.status == 'Reserve'
                                                ? 'color:#D500F9'
                                                : 'color:#0097A7'
                                        "
                                    >
                                        <v-icon class="pr-1 pb-1" small
                                            >mdi-pound</v-icon
                                        >
                                        <span> {{ part.part_name }} </span>
                                        <span class="font-weight-light">{{
                                            part.part_description
                                        }}</span>
                                        <span v-if="part.ship_date != null">
                                            ( {{ part.ship_date_x }} )
                                        </span>
                                        <span
                                            class="ml-1"
                                            v-if="part.status == 'Reserve'"
                                        >
                                            *ใช้ Spare part ที่ศูนย์
                                        </span>
                                        <span v-else class="ml-1">
                                            {{ "*" + part.status }}
                                        </span>
                                    </p>
                                </div>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>

        <!-- {{ case_types + "/" + chk_save }} -->
        <v-col
            cols="10"
            class="text-right"
            v-if="
                chkViewMain === 'managecase' &&
                    chk_save === false &&
                    (case_types === 'hp' || case_types === 'asus')
            "
        >
            <v-btn
                color="lime accent-3"
                fab
                fixed
                align-self-end
                bottom
                style="z-index: 100; margin-bottom: 65px"
            >
                <div v-if="chk_dataLoad === false">
                    {{ count_click_onhand + "/" + count_onhand }}
                </div>
                <img
                    v-if="chk_dataLoad === true"
                    src="../../../assets/all/Loading.gif"
                    style="width: 8.5%"
                />
            </v-btn>
        </v-col>

        <v-row v-if="chkViewMain === 'managecase' && chk_save === true">
            <v-col cols="10" class="text-right">
                <v-btn
                    color="success darken-1"
                    rounded
                    fixed
                    align-self-end
                    bottom
                    style="z-index: 100; margin-bottom: 65px"
                    @click="save()"
                >
                    <v-icon small class="mr-1">mdi-content-save</v-icon>
                    Save
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

const debounce = (func, delay) => {
    let inDebounce
    return function() {
        const context = this
        const args = arguments
        clearTimeout(inDebounce)
        inDebounce = setTimeout(() => func.apply(context, args), delay)
    }
}

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    props: ["chkViewMain"],
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
        ...mapState(["chk_token"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateToken"]),
        async get_data() {
            let { data } = await axios.get(url + "engineer/main-data/", this.tk)
            // console.log(data, "-menu1")
            this.data_main = data.pending_menu
            this.data_member = data.engineer
            if (data.pending_menu[1] || data.pending_menu[2]) {
                this.count_onhand =
                    parseInt(data.pending_menu[1].total_case) +
                    parseInt(data.pending_menu[2].total_case)
            }

            // await axios
            //     .get(url + "engineer/check-permission-assign/", this.tk)
            //     .then((response) => {
            //         console.log(response, "-test log")
            //         // status : 'lock' = ไม่สามารถจ่ายงานได้
            //         // status : 'all' = กดจ่ายงานได้ ต้องกด onhand ทุกเคส
            //         // status : 'some' = กดจ่ายงานได้ กดกี่เคสก็ได้
            //         this.chk_permission = response.data.status
            //     })
            //     .catch((error) => {
            //         console.log(error)
            //     })
        },
        async get_group(case_type) {
            console.log(case_type)
            this.func_chk_tk()
            this.case_types = case_type
            this.data_group = []

            if (this.list.length > 0) {
                this.page = 0
                this.last_page = 1
                this.list = []
            }

            await axios
                .get(
                    url + "engineer/check-permission-assign/" + case_type,
                    this.tk
                )
                .then((response) => {
                    console.log(
                        response.data,
                        "-engineer/check-permission-assign/"
                    )
                    // console.log(response, "-test log")
                    // status : 'lock' = ไม่สามารถจ่ายงานได้
                    // status : 'all' = กดจ่ายงานได้ ต้องกด onhand ทุกเคส
                    // status : 'some' = กดจ่ายงานได้ กดกี่เคสก็ได้
                    this.chk_permission = response.data.status
                    // console.log(this.chk_permission)
                })
                .catch((error) => {
                    console.log(error)
                })

            if (
                case_type === "back-order" ||
                case_type === "hp" ||
                case_type === "nonhp" ||
                case_type === "asus"
            ) {
                if (this.active_case_type === "B") {
                    this.count_click_onhand = 0
                    this.active_case_count = 0
                    this.data_save = []
                    this.active_member_en = []
                    this.add_members = []
                    this.chk_save = false

                    //new function 25/1/21
                    this.count_a.backOrder = 0
                    this.count_a.hp = 0
                    this.count_a.nonHp = 0
                    this.count_a.bench = 0
                    this.count_a.pmInstall = 0
                }
                this.active_case_type = "A"
                this.chk_active_member = ""
                this.change_member(
                    this.data_member[0].emp_id,
                    this.data_member[0].emp_name_en,
                    this.data_member[0].img_poth
                )

                // this.chk_active_member = ""
            } else {
                if (this.active_case_type === "A") {
                    this.count_click_onhand = 0
                    this.active_case_count = 0
                    this.data_save = []
                    this.active_member_en = []
                    this.add_members = []
                    this.chk_save = false

                    //new function 25/1/21
                    this.count_a.backOrder = 0
                    this.count_a.hp = 0
                    this.count_a.nonHp = 0
                    this.count_a.bench = 0
                    this.count_a.pmInstall = 0
                }
                this.active_case_type = "B"

                await axios
                    .get(url + "account-detail", this.tk)
                    .then((response) => {
                        this.chk_active_member = ""

                        this.change_member(
                            response.data.emp_id,
                            response.data.emp_name_en,
                            response.data.img_poth
                        )
                    })
            }
            // console.log(this.data_save)
            this.$emit("case")

            // this.mutateIsLoading()
            this.dialog_loading = true
            await axios
                .get(url + "engineer/pending-case/" + case_type, this.tk)
                .then((response) => {
                    console.log(response.data, "-engineer/pending-case")
                    // this.mutateIsLoading()
                    this.dialog_loading = false
                    this.data_group = response.data
                    this.data_group.map((data, key) => {
                        this.panel[key] = false
                    })
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_data_detail(group_type) {
            console.log(group_type, "-group_type")
            // this.mutateIsLoading()
            this.dialog_loading = true

            if (this.list.length > 0) {
                this.page = 0
                this.last_page = 1
                this.list = []
            }

            // console.log(this.list)
            this.group_types = group_type
            const response = await this.fetchItems(this.dataLimit, this.offset)
                .then((response) => {
                    console.log(response)
                    // this.mutateIsLoading()
                    this.dialog_loading = false
                    this.list = response.data

                    this.offset = this.dataLimit // updating offset
                    window.addEventListener(
                        "scroll",
                        debounce(this.scroll, 195)
                    )
                    this.last_page = response.last_page
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        async fetchItems(dataLimit, offset) {
            this.page += 1

            const response = await fetch(
                `${process.env.VUE_APP_ROOT_API}/api/engineer/pending-case/` +
                    this.case_types +
                    `/` +
                    this.group_types +
                    `?page=` +
                    this.page,
                this.tk
            )
            const json = await response.json()

            //เพิ่ม user เดิมที่มีในเคส แต่ยังไม่ได้วิ่งงานเข้าไป
            let data_fetch = json.data
            if (this.role_name === "WFH") {
                if (this.case_types === "hp" || this.case_types === "asus") {
                    //หารหัสคนกด

                    if (this.emp_id === null) {
                        await axios
                            .get(url + "account-detail", this.tk)
                            .then((response) => {
                                this.emp_id = response.data.emp_id
                            })
                    }

                    data_fetch.map((data, key) => {
                        if (
                            this.panel[this.active_num_tab] === true &&
                            (this.data_save[this.emp_id] === undefined ||
                                (this.data_save[this.emp_id] != undefined &&
                                    this.data_save[this.emp_id].includes(
                                        data.case_id
                                    ) === false))
                        ) {
                            this.data_member.map((r, h) => {
                                if (r.emp_id === this.emp_id) {
                                    if (
                                        this.active_member_en[this.emp_id] ===
                                        undefined
                                    ) {
                                        this.active_member_en[this.emp_id] = {
                                            emp_name_en: r.emp_name_en,
                                            img_poth: r.img_poth,
                                        }
                                    }
                                }
                            })

                            if (this.data_save[this.emp_id] === undefined) {
                                this.data_save[this.emp_id] = []
                            }
                            if (
                                this.case_types === "hp" ||
                                this.case_types === "asus"
                            ) {
                                this.count_click_onhand++
                            }
                            if (this.active_case_type === "B") {
                                this.active_case_count++
                            }

                            let makeIdCase = "I" + data.case_id
                            this.data_save[this.emp_id].push(data.case_id)
                            this.$set(this.add_members, makeIdCase, this.emp_id)
                        }
                    })

                    if (
                        this.count_click_onhand === parseInt(this.count_onhand)
                    ) {
                        // console.log(this.count_click_onhand)
                        // console.log(this.count_onhand)
                        this.chk_save = true
                    }
                }
            } else {
                data_fetch.map((data, key) => {
                    if (
                        data.engineer != "ZONE" &&
                        this.panel[this.active_num_tab] === true &&
                        (this.data_save[data.engineer] === undefined ||
                            (this.data_save[data.engineer] != undefined &&
                                this.data_save[data.engineer].includes(
                                    data.case_id
                                ) === false))
                    ) {
                        this.data_member.map((r, h) => {
                            if (r.emp_id === data.engineer) {
                                if (
                                    this.active_member_en[data.engineer] ===
                                    undefined
                                ) {
                                    this.active_member_en[data.engineer] = {
                                        emp_name_en: r.emp_name_en,
                                        img_poth: r.img_poth,
                                    }
                                }
                            }
                        })

                        if (this.data_save[data.engineer] === undefined) {
                            this.data_save[data.engineer] = []
                        }
                        if (
                            this.case_types === "hp" ||
                            this.case_types === "asus"
                        ) {
                            // แก้ไข 15/8/22
                            // this.count_click_onhand++
                            // this.count_a.hp++
                        } else if (this.case_types === "back-order") {
                            this.count_a.backOrder++
                        } else if (this.case_types === "nonhp") {
                            this.count_a.nonHp++
                        } else if (this.case_types === "bench") {
                            this.active_case_count++
                            this.count_a.bench++
                        } else if (this.case_types === "pm-install") {
                            this.active_case_count++
                            this.count_a.pmInstall++
                        }

                        // แก้ไข 15/8/22
                        // let makeIdCase = "I" + data.case_id
                        // this.data_save[data.engineer].push(data.case_id)
                        // this.$set(this.add_members, makeIdCase, data.engineer)
                    }
                })

                if (this.count_click_onhand === parseInt(this.count_onhand)) {
                    this.chk_save = true
                }
            }

            if (this.active_case_type === "B" && this.active_case_count > 0) {
                this.chk_save = true
            }
            // console.log(this.active_case_count)
            // console.log(this.count_a)
            return json
        },
        async addMoreItems() {
            if (
                this.page <= this.last_page &&
                this.panel[this.active_num_tab] === true
            ) {
                // this.mutateIsLoading()
                this.chk_dataLoad = true

                const response = await this.fetchItems(
                    this.dataLoadLimit,
                    this.offset
                )
                    .then((response) => {
                        // this.mutateIsLoading()
                        this.chk_dataLoad = false
                        this.list = this.list.concat(response.data)
                        this.offset = this.offset + this.dataLoadLimit
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        scroll() {
            let scrolledToBottom =
                document.documentElement.scrollTop + window.innerHeight ===
                document.documentElement.offsetHeight

            // if (scrolledToBottom) {
            if (this.page <= this.last_page) {
                debounce(this.addMoreItems, 300)()
            }
        },
        change_member(num, emp_name_en, img_poth) {
            if (this.chk_permission != "lock") {
                if (num === this.chk_active_member) {
                    this.chk_active_member = ""
                } else {
                    this.chk_active_member = num
                }

                if (
                    this.active_member_en[this.chk_active_member] === undefined
                ) {
                    this.active_member_en[this.chk_active_member] = {
                        emp_name_en: emp_name_en,
                        img_poth: img_poth,
                    }
                }

                if (this.data_save[this.chk_active_member] === undefined) {
                    this.data_save[this.chk_active_member] = []
                }
            }
        },
        func_panel(ii) {
            this.active_num_tab = ii
            this.panel.map((data, key) => {
                if (ii === key) {
                    this.panel[key] = !this.panel[key]
                } else {
                    this.panel[key] = false
                }
            })
        },
        async change_case(IdCase, site_province_id) {
            // console.log("change_case")
            if (this.chk_permission != "lock") {
                if (this.chk_active_member === "") {
                    this.$swal("กรุณาเลือกช่างที่ต้องการจ่ายงานก่อน !", {
                        icon: "warning",
                        button: false,
                        timer: 2000,
                    })
                } else {
                    let checkDupCase = false
                    let checkSameCE = false
                    let onhane_del = false

                    let chk_case_id = []

                    // api เช็ค group IN
                    // && this.team_name != "NONHP"

                    if (
                        this.case_types === "hp" ||
                        this.case_types === "asus"
                    ) {
                        // this.mutateIsLoading()
                        this.dialog_loading = true
                        await axios
                            .get(
                                url +
                                    "engineer/check-same-place/" +
                                    IdCase +
                                    "/" +
                                    site_province_id,
                                this.tk
                            )
                            .then((response) => {
                                chk_case_id = response.data
                                // this.mutateIsLoading()
                                this.dialog_loading = false
                            })
                            .catch((error) => {
                                console.log(error)
                            })
                    }

                    // console.log(this.data_save, "-this.data_save")
                    let chk_same = false
                    let keyMainSame = ""
                    for (let keyMain in this.data_save) {
                        this.data_save[keyMain].map((data, key) => {
                            if (data == IdCase) {
                                let index = key
                                checkDupCase = true
                                if (
                                    keyMain == this.chk_active_member &&
                                    chk_same === false
                                ) {
                                    // คนเดิม => ปลดเคสออก
                                    // console.log("คนเดิม => ปลดเคสออก")
                                    checkSameCE = true
                                } else {
                                    // คนใหม่ => confirm เตือนก่อน ที่จะย้ายคน
                                    // console.log(
                                    //     "คนใหม่ => confirm เตือนก่อน ที่จะย้ายคน"
                                    // )

                                    if (
                                        this.case_types === "hp" ||
                                        this.case_types === "asus"
                                    ) {
                                        keyMainSame = keyMain
                                        checkDupCase = true
                                        checkSameCE = true
                                    } else {
                                        this.data_save[keyMain].splice(index, 1)

                                        //นำเข้า
                                        let makeIdCase = "I" + IdCase
                                        this.data_save[
                                            this.chk_active_member
                                        ].push(IdCase)

                                        this.$set(
                                            this.add_members,
                                            makeIdCase,
                                            this.chk_active_member
                                        )
                                        checkSameCE = false
                                    }

                                    chk_same = true
                                }
                            }
                        })
                    }

                    if (!checkDupCase) {
                        if (
                            this.case_types === "hp" ||
                            this.case_types === "asus"
                        ) {
                            chk_case_id.map((caseid) => {
                                if (chk_case_id.length > 1) {
                                    this.$swal(
                                        "สถานที่เดียวกัน " +
                                            chk_case_id.length +
                                            " เคส",
                                        {
                                            icon: "success",
                                            button: false,
                                            timer: 1500,
                                        }
                                    )
                                }
                                let makeIdCase = "I" + caseid
                                if (
                                    this.data_save[this.chk_active_member][0] !=
                                    caseid
                                ) {
                                    this.data_save[this.chk_active_member].push(
                                        caseid
                                    )
                                    this.$set(
                                        this.add_members,
                                        makeIdCase,
                                        this.chk_active_member
                                    )
                                }
                            })
                        } else {
                            console.log("else", this.case_types, this.count_a)
                            if (this.active_case_type === "B") {
                                //new function 25/1/21
                                if (this.case_types === "bench") {
                                    this.count_a.bench++
                                } else if (this.case_types === "pm-install") {
                                    this.count_a.pmInstall++
                                }
                                this.active_case_count++
                            }

                            if (this.case_types === "back-order") {
                                this.count_a.backOrder++
                            } else if (this.case_types === "nonhp") {
                                this.count_a.nonHp++
                            }

                            let makeIdCase = "I" + IdCase
                            this.data_save[this.chk_active_member].push(IdCase)
                            this.$set(
                                this.add_members,
                                makeIdCase,
                                this.chk_active_member
                            )
                        }
                    } else {
                        if (checkSameCE) {
                            if (
                                this.case_types === "hp" ||
                                this.case_types === "asus"
                            ) {
                                if (keyMainSame === "") {
                                    this.data_save[this.chk_active_member].map(
                                        (data, key) => {
                                            if (
                                                chk_case_id.indexOf(data) >= 0
                                            ) {
                                                //ยังหาวิธีที่ดีกว่านี้ไม่ได้
                                                let index = key
                                                let makeIdCase = "I" + data
                                                this.$set(
                                                    this.add_members,
                                                    makeIdCase,
                                                    ""
                                                )
                                            }
                                        }
                                    )

                                    this.data_save[
                                        this.chk_active_member
                                    ] = this.data_save[
                                        this.chk_active_member
                                    ].filter(
                                        (item) => !chk_case_id.includes(item)
                                    )
                                } else {
                                    this.data_save[keyMainSame].map(
                                        (data, key) => {
                                            if (
                                                chk_case_id.indexOf(data) >= 0
                                            ) {
                                                //ยังหาวิธีที่ดีกว่านี้ไม่ได้
                                                let index = key
                                                let makeIdCase = "I" + data
                                                this.$set(
                                                    this.add_members,
                                                    makeIdCase,
                                                    ""
                                                )
                                            }
                                        }
                                    )

                                    this.data_save[
                                        keyMainSame
                                    ] = this.data_save[keyMainSame].filter(
                                        (item) => !chk_case_id.includes(item)
                                    )

                                    //นำเข้า
                                    chk_case_id.map((caseid) => {
                                        let makeIdCase = "I" + caseid
                                        this.data_save[
                                            this.chk_active_member
                                        ].push(caseid)
                                        this.$set(
                                            this.add_members,
                                            makeIdCase,
                                            this.chk_active_member
                                        )
                                    })
                                    // console.log(this.count_click_onhan)
                                    // console.log(chk_case_id.length)
                                    this.count_click_onhand +=
                                        chk_case_id.length

                                    this.count_a.hp += chk_case_id.length
                                }
                                if (this.chk_permission === "all") {
                                    // this.count_click_onhand -= 1
                                    this.count_click_onhand -=
                                        chk_case_id.length
                                    onhane_del = true
                                    this.chk_save = false

                                    this.count_a.hp -= chk_case_id.length
                                }
                            } else {
                                this.data_save[this.chk_active_member].map(
                                    (data, key) => {
                                        if (data == IdCase) {
                                            let index = key
                                            let makeIdCase = "I" + IdCase

                                            this.$set(
                                                this.data_save[
                                                    this.chk_active_member
                                                ],
                                                index,
                                                ""
                                            )

                                            if (this.active_case_type === "B") {
                                                this.active_case_count--
                                                if (
                                                    this.case_types === "bench"
                                                ) {
                                                    this.count_a.bench--
                                                } else if (
                                                    this.case_types ===
                                                    "pm-install"
                                                ) {
                                                    this.count_a.pmInstall--
                                                }
                                            }

                                            if (
                                                this.case_types === "back-order"
                                            ) {
                                                this.count_a.backOrder--
                                            } else if (
                                                this.case_types === "nonhp"
                                            ) {
                                                this.count_a.nonHp--
                                            }

                                            this.data_save[
                                                this.chk_active_member
                                            ].splice(index, 1)

                                            this.$set(
                                                this.add_members,
                                                makeIdCase,
                                                ""
                                            )
                                        }
                                    }
                                )
                            }
                        }
                    }

                    console.log(
                        this.chk_permission,
                        this.active_case_type,
                        this.active_case_count
                    )
                    if (this.chk_permission === "all") {
                        if (
                            (this.case_types === "hp" ||
                                this.case_types === "asus") &&
                            this.count_click_onhand <
                                parseInt(this.count_onhand) &&
                            onhane_del === false
                        ) {
                            // this.count_click_onhand += 1
                            this.count_click_onhand += chk_case_id.length
                            this.count_a.hp += chk_case_id.length
                        }

                        if (onhane_del === true) {
                            onhane_del = false
                        }

                        if (
                            this.count_click_onhand >=
                            parseInt(this.count_onhand)
                        ) {
                            this.chk_save = true
                        }
                    } else if (this.chk_permission == "some") {
                        console.log("else some")
                        this.chk_save = true
                    }

                    if (
                        this.active_case_type === "B" &&
                        this.active_case_count > 0
                    ) {
                        this.chk_save = true
                    } else if (
                        this.active_case_type === "B" &&
                        this.active_case_count === 0
                    ) {
                        this.chk_save = false
                    }

                    // console.log(this.count_click_onhand, "-count_click_onhand")
                    // console.log(parseInt(this.count_onhand), "-count_onhand")
                    // console.log(this.add_members, "-add_members")
                    // console.log(this.data_save, "-data_save")
                }
            }
        },
        async save() {
            console.log(this.data_save)
            // this.mutateIsLoading()
            this.dialog_loading = true
            await axios
                .post(
                    url + "engineer/save-assign-ce",
                    { data: { ...this.data_save } },
                    this.tk
                )
                .then((response) => {
                    console.log(response)
                    this.mutatesnackbar()

                    this.count_onhand = 0
                    this.count_click_onhand = 0
                    this.case_types = ""
                    this.data_group = []
                    this.chk_active_member = ""
                    this.chk_permission = ""
                    this.active_member_en = []
                    this.add_members = []
                    this.data_save = []
                    this.chk_save = false
                    // this.get_data()

                    // console.log(this.chkViewMain, "-chkViewMain")
                    this.get_data()
                    this.$emit("homePage")
                    // this.$emit("pageToFoot", this.chkViewMain)
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                    // this.mutateIsLoading()
                    this.dialog_loading = false
                    // this.data_group = response.data
                })
                .catch((error) => {
                    this.mutateIsLoading()
                    console.log(error)
                })
        },
        func_chk_tk() {
            let date_a = new Date()
            let date = new Date(localStorage.storagetime)
            let seconds = (date_a - date) / 1000
            if (seconds > 0) {
                this.mutateToken()
            }
        },
        doCopyLog: function(textId) {
            this.text_copy = textId
            navigator.clipboard.writeText(this.text_copy)
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },
    },
    data() {
        return {
            text_copy: "",
            data_main: [],
            data_save: [],
            data_member: [],
            data_group: [],
            list: [],
            case_types: "",
            group_types: "",
            chk_active_member: "",
            active_member_en: [],
            add_members: [],
            page: 0,
            last_page: 1,
            group_type: "",
            dataLimit: 10,
            chk_dataLoad: false,
            dataLoadLimit: 5,
            offset: 0,
            chk_save: false,
            chk_case_type: "",
            text: "Success, Your work has been saved",
            chk_permission: "",
            count_onhand: 0,
            count_click_onhand: 0,
            team_name: localStorage.team_name,
            role_name: localStorage.role_name,
            // url_pic: `${process.env.VUE_APP_ROOT_API}/api/case/attachments/`,
            url_pic_img: `${process.env.VUE_APP_ROOT_API}/api/profile_img/`,
            tk: "",
            emp_id: null,
            panel: [],
            active_num_tab: null,
            active_case_type: null,
            active_case_count: 0,
            count_a: {
                backOrder: 0,
                hp: 0,
                nonHp: 0,
                bench: 0,
                pmInstall: 0,
                asus: 0,
            },
            dialog_loading: false,
        }
    },
}
</script>

<style scoped>
.div-scoll-case {
    overflow: auto;
    width: 100%;
    height: 190px;
}
.fix-f-14 {
    font-size: 8.8px;
    margin-left: -7px;
}
.swal-overlay {
    background-color: rgba(82, 142, 170, 0.45);
}
.no-pd-row {
    padding: 0px !important;
}
.fix-font-1 {
    font-size: 9.4px !important;
}
.fix-font-2 {
    font-size: 10px !important;
}
.fix-font-3 {
    font-size: 8px !important;
    margin-bottom: 0px;
}
.fix-mar-1 {
    margin-top: -17px !important;
}
.fix-mar-2 {
    margin-top: -8px !important;
}
.fix-en-pic {
    padding: 0px !important;
    width: 90px !important;
    margin-bottom: 7px !important;
    margin-top: 7px !important;
}
.fix-hr-1 {
    /* margin-left: -36px !important;
    margin-right: -36px !important; */
    display: block;
    border: 0;
    border-top: 1px solid rgb(218, 218, 218);
}
.red-x {
    background-color: rgb(181, 253, 225);
    border-radius: 20px;
}
.fix-font-b {
    font-size: 16px;
    /* color: #0277bd; */
    color: #fff;
    font-weight: bold;
}
/* .fix-font-c {
    font-size: 12px;
    font-weight: bold;
} */

.color-font-c-1 {
    color: rgb(78, 113, 153);
}

.color-font-c-2 {
    color: rgb(26, 57, 126);
}

.color-font-c-3 {
    color: rgb(212, 46, 41);
}

.color-font-c-4 {
    color: rgb(37, 131, 0);
}
/* .mar-g1 {
    margin-top: -20px !important;
} */
.v-expansion-panel-content__wrap {
    padding: 1px 10px !important;
}
.v-banner__wrapper,
.v-banner__content {
    padding: 0px !important;
}
.icon-main-menu {
    color: rgb(40, 79, 151);
}

.icon-main-menu:hover {
    color: rgb(29, 129, 211) !important;
    font-size: 42px !important;
}
.color-active {
    color: rgb(25, 146, 110);
    font-weight: 800;
}
</style>
